module.exports = "//img1.rrcimg.com/_next/static/src/assets/qd_2xZ6z.png";